import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CursorIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M13.76 4.314 8.285 1.078a.56.56 0 0 0-.568 0L2.239 4.314A.49.49 0 0 0 2 4.738v6.524a.49.49 0 0 0 .24.424l5.476 3.236a.56.56 0 0 0 .568 0l5.477-3.236a.49.49 0 0 0 .24-.424V4.738a.49.49 0 0 0-.24-.424m-.343.685L8.13 14.37c-.036.063-.13.038-.13-.036V8.198a.35.35 0 0 0-.168-.297L2.639 4.833c-.061-.037-.036-.133.035-.133h10.574c.15 0 .244.166.17.3z"
			clipRule="evenodd"
		></path>
	</svg>
))
